import {FC} from 'react'
import {useIntl} from 'react-intl'
import {ErrorMessage} from '../../../../app/modules/errors/formikMessages/errorMessages'
import {getIn} from 'formik'

interface FormSelectObjectProps<T> {
  name: string
  label: string
  data: T[]
  formik: any
  idKey: keyof T
  nameKey: keyof T
  disabled?: boolean // Nueva propiedad opcional
}

const FormSelectObject: FC<FormSelectObjectProps<any>> = ({
  name,
  label,
  data,
  formik,
  idKey,
  nameKey,
  disabled = false, // Valor por defecto: false
}) => {
  const intl = useIntl()

  // Obtener el valor actual usando getIn para manejar objetos anidados
  const currentValue = getIn(formik.values, name)

  // Obtener errores usando getIn para manejar objetos anidados
  const error = getIn(formik.errors, name)
  const touched = getIn(formik.touched, name)

  // Obtener el valor para el select
  const selectValue = currentValue?.[idKey] || ''

  return (
    <div className='form-floating col-12 my-3 px-1 position-relative'>
      <select
        className={`form-select form-select-solid ${error && touched ? 'is-invalid' : ''}`}
        data-kt-select2='true'
        data-placeholder={intl.formatMessage({id: label})}
        data-allow-clear='true'
        data-hide-search='true'
        onChange={(e) => {
          const selectedId = e.target.value
          if (selectedId === '') {
            formik.setFieldValue(name, null)
          } else {
            const selected = data.find((item) => String(item[idKey]) === selectedId)
            formik.setFieldValue(name, selected || null)
          }
        }}
        onBlur={() => formik.setFieldTouched(name, true)}
        value={selectValue}
        disabled={disabled} // Agregado aquí
      >
        <option value='' disabled>
          {intl.formatMessage({id: label})}
        </option>
        {data.map((item) => (
          <option key={String(item[idKey])} value={String(item[idKey])}>
            {String(item[nameKey])}
          </option>
        ))}
      </select>
      <label htmlFor={name}>{intl.formatMessage({id: label})}</label>

      <div style={{minHeight: '24px'}}>
        {touched && error && (
          <ErrorMessage
            errorMessage={
              typeof error === 'string'
                ? intl.formatMessage({id: error})
                : typeof error === 'object' && error.id
                ? intl.formatMessage({id: error.id})
                : error
            }
          />
        )}
      </div>
    </div>
  )
}

export default FormSelectObject
